import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationInlineType } from '@maced/angular-components/lib/notification-inline/notification-inline.model';

@Component({
  selector: 'app-notification-inline',
  templateUrl: './notification-inline.component.html',
  styleUrls: ['./notification-inline.component.scss']
})
export class NotificationInlineComponent {
  showNotificationInline: boolean = false;
  type: NotificationInlineType = 'success';
  typeList: NotificationInlineType[] = ['success', 'warning', 'error', 'info'];
  closeButtonArialabel: string = 'Close';
  hasCloseButton = true;
  hasAcordian = false;
  hasDefinedIcon = false;
  hasModifiedIcon = true;
  notificationModifiedIcon = 'icon-add-to-favourite' as string;
  accordianOpenLabel: string = 'Open';
  accordianCloseLabel: string = 'Close';
  ariaLabel: string = 'Notification Aria Label';
  currentUrl: string = '';
  link: { label: string, hyperLink: string,  srOnlyLabel: string} = { label: 'Action', srOnlyLabel: 'open in new window', hyperLink: '/button' };
  constructor(
    private _activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.currentUrl = this.router.url.split('?')[0];
  }

  ngOnInit() {
    this._activatedRoute.queryParams.subscribe(param => {
      if (param.notificationInlineId) {
        this.showNotificationInline = (param.isOpen === "true");
        document.getElementById('NotificationInlineButton')?.focus();
      }
    });
  }
}